export type Region = "韩国" | "中国" | "日本" | "中国香港" | "美国" | "法国";

export type CastMember = {
  name: string;
  role: string;
  note: string;
};

export type Film = {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  region: Region;
  genres: string[];
  rating: number;
  duration: number;
  director: string;
  writers: string[];
  cast: CastMember[];
  tagline: string;
  synopsis: string;
  analysis: string[];
  tags: string[];
  poster: string;
  still: string;
  featured: boolean;
  popularity: number;
};

export const genres = ["剧情", "喜剧", "爱情", "传记", "文艺", "青春", "纪录片", "历史", "悬疑", "家庭"];

export const regions = ["全部", "韩国", "中国", "日本", "中国香港", "美国", "法国"];

export const films: Film[] = [
  {
    id: "1",
    title: "色即是空",
    originalTitle: "색즉시공 / Sex Is Zero",
    year: 2002,
    region: "韩国",
    genres: ["喜剧", "爱情", "青春"],
    rating: 8.4,
    duration: 96,
    director: "尹齐均",
    writers: ["尹齐均", "金贤秀"],
    cast: [
      { name: "任昌丁", role: "朴英洙", note: "大龄校园生，暗恋恩植的痴情男主角，以夸张的身体喜剧完成一次次狼狈的告白。" },
      { name: "河智苑", role: "李恩植", note: "校园里的「体能女王」，外表强势内心柔软，在友情与爱意之间反复摇摆。" },
      { name: "陈载英", role: "李相宇", note: "校园风云人物，恩植的旧日恋人，是爱情三角关系里最不可靠的那个支点。" },
      { name: "姜成镇", role: "千成国", note: "英洙的室友，永远在最后一刻把计划搞砸，却也是全片最真诚的兄弟。" },
      { name: "刘彩英", role: "允静", note: "健美操社的好友，直率敢言，为闺蜜操心的同时又忍不住吐槽。" },
    ],
    tagline: "青春里最狼狈的那次喜欢，笑过之后才发现自己也哭过。",
    synopsis:
      "年过三十的朴英洙仍在大学里念书，住在拥挤的宿舍，与室友千成国一起过着毫无章法的日子。一次健美操比赛，他遇见了体能出众、性格强硬的李恩植，从此开始了笨拙又执拗的暗恋。为了接近她，他参加社团、充当搬运工、被误伤、被误会，也在这些笑料里第一次认真审视自己。恩植的旧日恋人李相宇重返校园，三人关系被推向最尴尬的时刻。当一场意外的伤病把所有人拉回现实，英洙终于不再用闹剧掩饰真心，而恩植也在无数次的荒唐之后，认出了那个始终站在原处的人。",
    analysis: [
      "影片以身体喜剧为外壳，实则在讲一个很朴素的主题：如何在被看轻的人生里认真喜欢一个人。英洙的每一次失败，都不只是笑点，而是一次次被消解的自我价值。",
      "尹齐均把校园处理成一个微缩社会，社团、宿舍、比赛与派对都是权力关系的舞台。恩植的强与英洙的弱互为镜像，让爱情片多了几分社会观察的层次。",
    ],
    tags: ["经典喜剧", "校园爱情", "青春成长", "韩国 2000s"],
    poster:
      "https://readdy.ai/api/search-image?query=Minimalist%20Korean%20film%20poster%20design%2C%20soft%20cream%20paper%20texture%2C%20a%20lone%20red%20paper%20lantern%20and%20two%20silhouettes%20of%20young%20students%20walking%20under%20a%20university%20arcade%2C%20warm%20orange%20and%20deep%20indigo%20color%20palette%20with%20fine%20grain%2C%20art%20house%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=sjs-01-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20Korean%20university%20campus%20staircase%20in%20late%20afternoon%2C%20warm%20orange%20sunlight%20raking%20across%20concrete%20steps%2C%20two%20distant%20students%20walking%20with%20books%2C%20deep%20indigo%20shadows%2C%20filmic%20grain%2C%20melancholic%20nostalgic%20mood&width=1600&height=900&seq=sjs-01-still&orientation=landscape",
    featured: true,
    popularity: 98,
  },
  {
    id: "2",
    title: "空即是色",
    originalTitle: "색즉시공 2 / Sex Is Zero 2",
    year: 2007,
    region: "韩国",
    genres: ["喜剧", "爱情"],
    rating: 7.6,
    duration: 108,
    director: "尹泰允",
    writers: ["金允哲", "尹泰允"],
    cast: [
      { name: "李志勋", role: "金成旭", note: "为爱备战司法考试的复读生，执念深重，执拗得让人又心疼又好笑。" },
      { name: "安雅英", role: "韩知恩", note: "明朗的烘焙科学生，笑起来很大声，难过的时候却只肯一个人走很远的路。" },
      { name: "玄英", role: "秀贤", note: "成旭的合伙人也是损友，所有不靠谱的建议都来自他。" },
      { name: "金成民", role: "教务处长", note: "爱面子却心软的老派老师，是校园秩序和笑话的双重来源。" },
    ],
    tagline: "成年人的荒唐从不是爱情的对立面，而是它的注脚。",
    synopsis:
      "金成旭第五次准备司法考试，又一次失败。为了不让家人失望，他谎称已经进入大律所实习，每天在图书馆和便利店之间维持着脆弱的假象。韩知恩在烘焙课上认识了他，看见的却是那个谎言之下的疲惫。两人从互相拆穿到彼此掩护，把一段本来荒唐的关系过成了日常。当谎言终于被家人当面拆开，成旭必须回答一个更狠的问题：他执着的到底是考试，还是不敢成为一个普通人的自己。",
    analysis: [
      "续集把校园喜剧的场域推进到「即将成年」的门槛，笑点从身体转向谎言的连锁反应，难度更高也更贴合现实。",
      "影片的价值在于它没有把失败浪漫化。成旭最终获得的不是成功，而是一种承认自己平庸的勇气，这使结尾的拥抱有了分量。",
    ],
    tags: ["续集", "考试人生", "爱情喜剧", "自我和解"],
    poster:
      "https://readdy.ai/api/search-image?query=Minimalist%20film%20poster%20in%20warm%20beige%20tones%2C%20a%20stack%20of%20thick%20law%20books%20beside%20a%20cup%20of%20coffee%20and%20a%20pink%20apron%2C%20soft%20window%20light%2C%20deep%20navy%20accents%2C%20quiet%20editorial%20still%20life%20composition%2C%20fine%20paper%20grain%2C%20no%20text&width=600&height=900&seq=sjs-02-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Warm%20sunlit%20Korean%20bakery%20kitchen%20with%20flour%20dust%20in%20the%20air%2C%20wooden%20counter%2C%20trays%20of%20bread%2C%20a%20single%20figure%20in%20an%20apron%20seen%20from%20behind%2C%20soft%20amber%20light%20and%20deep%20blue%20shadows%2C%20filmic%20texture&width=1600&height=900&seq=sjs-02-still&orientation=landscape",
    featured: true,
    popularity: 84,
  },
  {
    id: "3",
    title: "悲梦",
    originalTitle: "비몽 / Dream",
    year: 2008,
    region: "韩国",
    genres: ["剧情", "爱情", "悬疑"],
    rating: 7.2,
    duration: 95,
    director: "金基德",
    writers: ["金基德"],
    cast: [
      { name: "小田切让", role: "镇", note: "被自己的梦牵着走的青年，清醒时沉默，睡着后却成为另一个人。" },
      { name: "李奈映", role: "兰", note: "入狱后不断做同一个梦的女子，与镇形成无法拆开的梦境联结。" },
      { name: "朴智雅", role: "美静", note: "镇的前恋人，故事的起点，也是一切悔意的来源。" },
    ],
    tagline: "梦里做过的事，醒来要不要负责。",
    synopsis:
      "镇在车祸之后不断做一个梦：他与人争夺，最后把人推下楼梯。与此同时，正在服刑的兰也反复梦见一模一样的场景。出狱后兰找到镇，两人发现只要其中一人入睡，另一人就会在现实里完成梦中的动作。他们尝试互相约束、互相陪伴，甚至一起生活，却发现梦与现实的边界正在崩塌。片子追问的并不是谁是凶手，而是一个人能否为另一个人的潜意识承担代价。",
    analysis: [
      "金基德用极简的场景和几乎无声的段落，把关系拍成了某种睡眠中的物理状态，情绪始终悬在边缘。",
      "影片常被读作对爱情占有欲的隐喻：当两个人在梦里交换身体，爱就同时变成了审讯与赎罪。",
    ],
    tags: ["梦境", "作者电影", "心理", "金基德"],
    poster:
      "https://readdy.ai/api/search-image?query=Dreamlike%20minimalist%20film%20poster%2C%20a%20pair%20of%20eyes%20dissolving%20into%20dark%20water%20ripples%2C%20deep%20indigo%20and%20warm%20amber%20duotone%2C%20heavy%20grain%2C%20textured%20paper%20surface%2C%20art%20house%20composition%2C%20no%20text&width=600&height=900&seq=sjs-03-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Empty%20Korean%20apartment%20at%20blue%20hour%2C%20a%20single%20dim%20lamp%2C%20person%20sleeping%20on%20a%20bare%20floor%20with%20a%20thin%20blanket%2C%20cold%20moonlight%20through%20sheer%20curtain%2C%20deep%20teal%20and%20indigo%20gradient%2C%20somber%20filmic%20atmosphere&width=1600&height=900&seq=sjs-03-still&orientation=landscape",
    featured: false,
    popularity: 66,
  },
  {
    id: "4",
    title: "空房子",
    originalTitle: "빈집 / 3-Iron",
    year: 2004,
    region: "韩国",
    genres: ["剧情", "爱情", "文艺"],
    rating: 8.1,
    duration: 88,
    director: "金基德",
    writers: ["金基德"],
    cast: [
      { name: "在熙", role: "泰石", note: "骑摩托的青年，白天在别人家的空房子里生活，从不留下痕迹。" },
      { name: "李丞涓", role: "善华", note: "被困在漂亮房子里的女人，用沉默完成了全片最重要的反抗。" },
      { name: "权赫镐", role: "善华的丈夫", note: "看似体面的成功男人，把家庭变成了他最讲究的牢笼。" },
    ],
    tagline: "最有力量的一句话，是他从头到尾都没有开口。",
    synopsis:
      "泰石每天天不亮就骑摩托在街区里寻找空置的住宅。他开锁、住下、洗衣、修坏掉的电器，再安静离开。一次他遇见了被丈夫冷待的善华，两个几乎不说话的人开始一起流浪。当善华被带回原来的生活，泰石选择用更极端的方式留下：让自己成为一个不被看见的人，站在她的影子里。结尾里两人一起站上体重秤，秤上的数字是零。",
    analysis: [
      "几乎全片对白不超过十句，所有信息都靠空间、动作与沉默完成，是极少有的「不需要语言的爱」。",
      "空房子同时是占有与庇护：别人的家、别人的婚姻、别人的价值，主角不是闯入者，而是提醒它们已经空了的那个声音。",
    ],
    tags: ["极简主义", "沉默叙事", "作者电影", "经典"],
    poster:
      "https://readdy.ai/api/search-image?query=Quiet%20minimalist%20film%20poster%2C%20empty%20Korean%20room%20with%20one%20sunlit%20window%2C%20a%20chair%2C%20a%20small%20suitcase%20on%20the%20floor%2C%20pale%20beige%20walls%20with%20deep%20navy%20shadow%2C%20soft%20film%20grain%2C%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=sjs-04-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Deserted%20bright%20Korean%20apartment%20with%20white%20walls%2C%20sunlight%20cutting%20a%20sharp%20diagonal%20on%20the%20floor%2C%20a%20bicycle%20out%20of%20focus%20near%20the%20window%2C%20muted%20beige%20and%20shadow%20tones%2C%20minimal%20cinematic%20framing&width=1600&height=900&seq=sjs-04-still&orientation=landscape",
    featured: true,
    popularity: 88,
  },
  {
    id: "5",
    title: "长江图",
    originalTitle: "Crosscurrent",
    year: 2016,
    region: "中国",
    genres: ["剧情", "文艺", "爱情"],
    rating: 7.5,
    duration: 119,
    director: "杨超",
    writers: ["杨超", "杜欢"],
    cast: [
      { name: "秦昊", role: "高淳", note: "承运货船的船长，逆流而上，也在时间里往回走。" },
      { name: "辛芷蕾", role: "安陆", note: "在每一个码头等他出现的女子，名字相同，命运却层层不同。" },
      { name: "邬立朋", role: "武胜", note: "船上的年轻水手，是现实与诗之间的那个提问者。" },
    ],
    tagline: "一条江，倒着流，人会走回哪里。",
    synopsis:
      "高淳驾驶货船从入海口一路向重庆开去。沿途他在不同码头遇到一个总叫「安陆」的女子，每一次相遇都更年轻一点，也更决绝一点。航线在向前，故事却在向后，江面上的雾、废弃的城镇与被淹没的旧居构成了另一个时间。最终高淳发现父亲留下的手稿里写满这条水路，也写满了他自己。",
    analysis: [
      "全片以黑白与彩色的交替标记记忆与现实，长江被拍成一个可见的时间轴，水流方向就是叙事方向。",
      "它不是常规的爱情故事，而是一部关于地方、记忆与失落的地景诗，适合慢慢看，也适合反复看。",
    ],
    tags: ["当代中国电影", "诗意影像", "长江", "摄影"],
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20minimalist%20film%20poster%2C%20misty%20river%20with%20a%20single%20cargo%20ship%20silhouette%2C%20pale%20grey%20and%20warm%20amber%20duotone%2C%20heavy%20fog%20texture%2C%20fine%20grain%20paper%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=sjs-05-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20monochrome%20river%20landscape%20at%20dawn%2C%20old%20cargo%20ship%20cutting%20through%20dense%20fog%2C%20distant%20hills%20and%20a%20half%20submerged%20town%2C%20moody%20grey%20tones%20with%20a%20warm%20sun%20patch%2C%20cinematic%20composition&width=1600&height=900&seq=sjs-05-still&orientation=landscape",
    featured: true,
    popularity: 71,
  },
  {
    id: "6",
    title: "春天的故事",
    originalTitle: "Conte de printemps / A Tale of Springtime",
    year: 1990,
    region: "法国",
    genres: ["剧情", "爱情", "文艺"],
    rating: 7.8,
    duration: 107,
    director: "埃里克·侯麦",
    writers: ["埃里克·侯麦"],
    cast: [
      { name: "安娜·泰塞德尔", role: "让娜", note: "教哲学的女教师，习惯用理性安排生活，却被一场感冒打乱了秩序。" },
      { name: "弗洛朗斯·达雷尔", role: "娜塔莎", note: "年轻又任性的女孩，热衷于给别人安排生活，也热衷于替自己找一个母亲。" },
      { name: "埃卢瓦·贝内", role: "伊戈尔", note: "娜塔莎的父亲，身边总有人，却始终没有停下来过。" },
    ],
    tagline: "春天不解决任何问题，只是让人愿意再试一次。",
    synopsis:
      "让娜的公寓被表妹临时占用，她只好暂时借住在聚会认识的娜塔莎家。娜塔莎的家里摆着许多东西，也摆着许多未说出口的情绪：父亲的年轻女友、母亲的离开、以及一个还没被填补的空位。娜塔莎甚至想把让娜介绍给父亲。三个成年人围绕一个周末的花园、一顿晚餐、一句被听错的话，来回试探，什么也没有发生，又好像什么都已经结束。",
    analysis: [
      "侯麦的对话从不是闲聊，每一次叙述都在重新分配关系中的位置，观众需要自己判断谁说了真话。",
      "影片的色彩是季节最漂亮的注解：嫩绿、浅黄、灰蓝，把春天的犹疑拍成了一种可以呼吸的温度。",
    ],
    tags: ["法国新浪潮", "四季故事", "对话电影", "春天"],
    poster:
      "https://readdy.ai/api/search-image?query=Light%20French%20film%20poster%2C%20soft%20spring%20garden%20in%20bloom%2C%20a%20white%20dress%20and%20a%20glass%20of%20white%20wine%20on%20a%20garden%20table%2C%20pale%20green%20and%20warm%20cream%20palette%2C%20gentle%20film%20grain%2C%20airy%20negative%20space%2C%20no%20text&width=600&height=900&seq=sjs-06-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Sunlit%20French%20countryside%20garden%20in%20early%20spring%2C%20blooming%20apple%20trees%2C%20a%20small%20white%20table%20with%20two%20glasses%2C%20light%20green%20foliage%20and%20soft%20cream%20light%2C%20gentle%20film%20grain%2C%20serene%20composition&width=1600&height=900&seq=sjs-06-still&orientation=landscape",
    featured: false,
    popularity: 62,
  },
  {
    id: "7",
    title: "小森林",
    originalTitle: "リトル・フォレスト / Little Forest",
    year: 2014,
    region: "日本",
    genres: ["剧情", "文艺", "家庭"],
    rating: 8.6,
    duration: 112,
    director: "森淳一",
    writers: ["五十岚大介", "森淳一"],
    cast: [
      { name: "桥本爱", role: "市子", note: "从城市回到山间小镇的年轻女子，用一道一道饭重新整理自己的记忆。" },
      { name: "三浦贵大", role: "佑太", note: "同乡的好友，说话直接，替她指出那些不愿面对的部分。" },
      { name: "松冈茉优", role: "吉子", note: "镇上的闺蜜，给日常添了最快的笑声。" },
    ],
    tagline: "好好做一顿饭，就是好好活下去的一种方法。",
    synopsis:
      "市子在城市里过不下去，回到东北山间的老家，独自生活在没有便利店的小镇。她没有宏大的计划，只是种地、采野菜、做面包、酿米酒，按季节把日子一格一格填满。在春天做草饼，夏天熬番茄罐头，秋天烤核桃饭，冬天煮冻萝卜。母亲留下的食谱是唯一的线索，也是最后的告白。当季节转回起点，她终于明白自己想要的不是逃离，而是选择。",
    analysis: [
      "影片把叙事节奏交给食物与季节，几乎没有冲突，观众却会被那种具体的劳作感稳稳托住。",
      "它不是田园牧歌式的幻想，而是一部关于「回到地方」的当代生活样本：用身体的劳动对抗精神的内耗。",
    ],
    tags: ["美食电影", "四季", "疗愈", "日本"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20Japanese%20film%20poster%2C%20rustic%20wooden%20table%20with%20seasonal%20vegetables%20and%20a%20bowl%20of%20rice%2C%20sunlight%20through%20a%20window%2C%20moss%20green%20and%20warm%20beech%20tones%2C%20grainy%20texture%2C%20calm%20composition%2C%20no%20text&width=600&height=900&seq=sjs-07-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Japanese%20mountain%20village%20in%20summer%2C%20small%20wooden%20kitchen%20with%20open%20window%2C%20a%20basket%20of%20fresh%20herbs%20and%20tomatoes%2C%20dappled%20green%20light%2C%20earthy%20tones%2C%20peaceful%20movie%20still&width=1600&height=900&seq=sjs-07-still&orientation=landscape",
    featured: true,
    popularity: 93,
  },
  {
    id: "8",
    title: "路边野餐",
    originalTitle: "Kaili Blues",
    year: 2015,
    region: "中国",
    genres: ["剧情", "文艺"],
    rating: 7.9,
    duration: 110,
    director: "毕赣",
    writers: ["毕赣"],
    cast: [
      { name: "陈永忠", role: "陈升", note: "诊所医生，出狱后学会和过去一起生活的人。" },
      { name: "谢理循", role: "老歪", note: "弟弟，替哥哥背负着没说出口的家庭责任。" },
      { name: "余世学", role: "卫卫", note: "侄子，是整趟旅途的终点，也是过去的入口。" },
    ],
    tagline: "时间是一条湿漉漉的路，走过去的人会变成另一个人。",
    synopsis:
      "凯里的陈升在诊所工作，某天得知侄子卫卫被送到了镇远的旧同事手里。他带着几件东西和一段口述的去向出发，一路经过隧道、渡口与小城，途中遇上的人与他说出的话，都像来自另一个时间。影片在最后一段拉起一段长达四十多分钟的长镜头，把空间变成了记忆的全部。",
    analysis: [
      "短片集的碎片结构和大胆的调度让地方性经验获得了普遍性，贵州的湿气变成叙事的气质。",
      "诗不是装饰，而是替代说明的叙事方法，观众要靠感受而不是线索去拼合人物关系。",
    ],
    tags: ["作者电影", "长镜头", "西南", "诗意"],
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20film%20poster%20in%20deep%20teal%20and%20warm%20amber%2C%20a%20rainy%20mountain%20road%20with%20a%20single%20streetlight%20and%20a%20distant%20bus%2C%20wet%20asphalt%20reflections%2C%20heavy%20grain%2C%20moody%20poetic%20composition%2C%20no%20text&width=600&height=900&seq=sjs-08-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Misty%20southwestern%20Chinese%20mountain%20town%20at%20dusk%2C%20narrow%20wet%20street%2C%20green%20tiled%20roofs%2C%20a%20lone%20figure%20walking%2C%20teal%20fog%20and%20warm%20window%20lights%2C%20filmic%20atmosphere&width=1600&height=900&seq=sjs-08-still&orientation=landscape",
    featured: false,
    popularity: 74,
  },
  {
    id: "9",
    title: "一一",
    originalTitle: "Yi Yi / A One and a Two",
    year: 2000,
    region: "中国",
    genres: ["剧情", "家庭"],
    rating: 9.1,
    duration: 173,
    director: "杨德昌",
    writers: ["杨德昌"],
    cast: [
      { name: "吴念真", role: "NJ", note: "温和的中年男人，在东京与旧爱重逢后，第一次问自己想要什么。" },
      { name: "金燕玲", role: "敏敏", note: "在城市生活里被日常掏空的女人，最终在山上找到自己。" },
      { name: "李凯莉", role: "婷婷", note: "十七岁的少女，在初恋里第一次尝到爱情的重量。" },
      { name: "张洋洋", role: "洋洋", note: "八岁的小男孩，用相机拍下所有大人的后脑勺。" },
    ],
    tagline: "电影让我们看见生活的另一半。",
    synopsis:
      "台北一个中产家庭的日常被几件事同时撕开：外婆忽然昏迷，NJ与小舅子的生意陷入僵局，敏敏在照护中崩溃，女儿婷婷第一次恋爱，儿子洋洋决定去拍下人们看不到的那一面。三小时的故事里没有一次真正的爆炸，只有缓慢渗进来的无常。它关于后来才明白的那些事——你看见的只是一半，另一半在别人眼里。",
    analysis: [
      "杨德昌用玻璃与镜面把人物分隔又叠合，观众始终以旁观的位置介入，这是典型的现代都市情感调度。",
      "影片让小孩成为最诚实的观察者，同时给了每个成年人一段可以独处的空白，这种温柔在同样题材里罕见。",
    ],
    tags: ["华语经典", "家庭", "都市", "长片"],
    poster:
      "https://readdy.ai/api/search-image?query=Refined%20minimalist%20Chinese%20film%20poster%2C%20a%20Taipei%20apartment%20window%20reflecting%20a%20family%20of%20four%20in%20soft%20focus%2C%20warm%20amber%20interior%20against%20deep%20indigo%20evening%2C%20grainy%20analog%20texture%2C%20generous%20negative%20space%2C%20no%20text&width=600&height=900&seq=sjs-09-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Taipei%20apartment%20interior%20at%20night%2C%20dining%20table%20with%20leftover%20dishes%2C%20a%20boy%20in%20the%20doorway%20holding%20an%20old%20camera%2C%20warm%20lamplight%20and%20cool%20blue%20window%20light%2C%20analog%20film%20grain&width=1600&height=900&seq=sjs-09-still&orientation=landscape",
    featured: true,
    popularity: 96,
  },
  {
    id: "10",
    title: "花样年华",
    originalTitle: "In the Mood for Love",
    year: 2000,
    region: "中国香港",
    genres: ["剧情", "爱情", "文艺"],
    rating: 8.8,
    duration: 98,
    director: "王家卫",
    writers: ["王家卫"],
    cast: [
      { name: "梁朝伟", role: "周慕云", note: "报社编辑，把感情写成小说，却没有写完最后一句。" },
      { name: "张曼玉", role: "苏丽珍", note: "秘书，旗袍换了一件又一件，心事却始终没换。" },
      { name: "潘迪华", role: "顾太太", note: "房东太太，走廊里的另一种注视。" },
    ],
    tagline: "如果多一张船票，你会不会跟我走。",
    synopsis:
      "1962 年的香港，两户人家搬到同一层楼。周慕云与苏丽珍因为各自的配偶而认识，先是礼貌，后来一起吃饭、一起写武侠小说、一起在巷口避雨。他们始终没有越过那条线，却在每一次狭窄的楼梯相遇里，把一生的情感用完。多年后，周慕云在吴哥窟的墙上说出一段无人听见的话。",
    analysis: [
      "影片以重复的旋律与错位的画框控制节奏，旗袍与走廊构成严格的视觉语法，观众几乎可以读出人物的犹豫。",
      "它最厉害的地方是把「没有发生」拍成了最强烈的感情，暧昧因此获得了真实的重量。",
    ],
    tags: ["王家卫", "港片经典", "旗袍", "暧昧"],
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20poster%2C%20narrow%20Hong%20Kong%20corridor%20with%20red%20curtains%20and%20green%20wall%20tiles%2C%20a%20woman%20in%20a%20qipao%20seen%20from%20behind%20in%20soft%20focus%2C%20deep%20crimson%20and%20amber%20tones%2C%20film%20grain%2C%20moody%20romantic%20composition%2C%20no%20text&width=600&height=900&seq=sjs-10-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=1960s%20Hong%20Kong%20alley%20at%20night%20with%20rain%2C%20warm%20streetlamp%20glow%20on%20wet%20walls%2C%20old%20posters%20and%20a%20narrow%20staircase%2C%20deep%20red%20and%20teal%20color%20palette%2C%20romantic%20melancholic%20film%20still&width=1600&height=900&seq=sjs-10-still&orientation=landscape",
    featured: true,
    popularity: 95,
  },
  {
    id: "11",
    title: "四百击",
    originalTitle: "Les Quatre Cents Coups",
    year: 1959,
    region: "法国",
    genres: ["剧情", "青春"],
    rating: 8.7,
    duration: 99,
    director: "弗朗索瓦·特吕弗",
    writers: ["弗朗索瓦·特吕弗", "马塞尔·穆西"],
    cast: [
      { name: "让-皮埃尔·莱奥", role: "安托万", note: "被所有人误解的少年，他的逃跑是一种最本能的反抗。" },
      { name: "克莱尔·莫里耶", role: "吉尔贝特", note: "安托万短暂的初恋，安静地站在青春期的一端。" },
      { name: "阿尔贝·雷米", role: "朱利安", note: "安托万的伙伴，见证了他所有失败的计划。" },
    ],
    tagline: "自由不是说走就走，而是没人愿意听你解释。",
    synopsis:
      "十三岁的安托万住在巴黎狭小的公寓里，父母忙于自己的生活，学校把他当作问题学生。逃课、撒谎、偷打字机，每一次恶作剧都被更严厉的惩罚回击。被送进少管所后，他从未被真正问过一句「为什么」。影片结尾他逃出球场，一路跑向海边，回头望向镜头的那一刻，成了电影史上最著名的一次凝视。",
    analysis: [
      "特吕弗把镜头放低到少年的高度，观众因此不是审判他，而是与他一起被困在成人的秩序里。",
      "那三个定格的镜头不是答案，而是一个问题：当一个人终于跑到海边，他还能往哪里去。",
    ],
    tags: ["新浪潮", "少年", "经典镜头", "法国"],
    poster:
      "https://readdy.ai/api/search-image?query=Black%20and%20cream%20minimalist%20French%20film%20poster%2C%20a%20boy%20running%20on%20a%20long%20empty%20beach%20toward%20the%20sea%2C%20high%20contrast%20grainy%20monochrome%20with%20one%20warm%20amber%20highlight%2C%20vintage%20textured%20paper%2C%20no%20text&width=600&height=900&seq=sjs-11-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Black%20and%20white%20cinematic%20beach%20scene%2C%20a%20teenage%20boy%20running%20toward%20the%20surf%2C%20wide%20empty%20shore%2C%20overcast%20sky%2C%20strong%20film%20grain%2C%20classic%20nouvelle%20vague%20framing&width=1600&height=900&seq=sjs-11-still&orientation=landscape",
    featured: false,
    popularity: 82,
  },
  {
    id: "12",
    title: "海边的曼彻斯特",
    originalTitle: "Manchester by the Sea",
    year: 2016,
    region: "美国",
    genres: ["剧情", "家庭"],
    rating: 8.4,
    duration: 137,
    director: "肯尼斯·洛纳根",
    writers: ["肯尼斯·洛纳根"],
    cast: [
      { name: "卡西·阿弗莱克", role: "李·钱德勒", note: "沉默的修理工，他把自己流放到离家乡最远的地方。" },
      { name: "米歇尔·威廉姆斯", role: "兰迪", note: "曾经的爱人，用一个电话把过去重新交还给他。" },
      { name: "卢卡斯·赫奇斯", role: "帕特里克", note: "少年侄子，用冰球和乐队撑起一个突然破碎的家。" },
    ],
    tagline: "有些悲伤不会被解决，只会被携带。",
    synopsis:
      "李在波士顿做杂工，寡言、暴躁、拒绝一切靠近。哥哥去世后，他回到海边的曼彻斯特处理后事，发现自己被指定为侄子帕特里克的监护人。冷冽的小镇、旧日的朋友、以及与前妻的重逢，把他一步步推回那场他自己也无法原谅的事故。他没有被治愈，也没有被拯救，只是学着把伤痛放在副驾驶上，继续开车。",
    analysis: [
      "影片用大量留白与冷色调海岸，让人物情绪在画外继续发酵，表演几乎全在沉默里完成。",
      "它拒绝提供和解的承诺，因此显得格外诚实：接受自己永远无法修复，也是一种活法。",
    ],
    tags: ["当代美国电影", "表演", "创伤", "冬天"],
    poster:
      "https://readdy.ai/api/search-image?query=Cold%20minimalist%20film%20poster%2C%20grey%20New%20England%20harbor%20with%20a%20small%20boat%20and%20bare%20trees%2C%20pale%20blue%20grey%20and%20warm%20amber%20accent%2C%20winter%20light%2C%20fine%20grain%2C%20quiet%20melancholic%20composition%2C%20no%20text&width=600&height=900&seq=sjs-12-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wintry%20New%20England%20harbor%20at%20grey%20dawn%2C%20frozen%20boats%20covered%20in%20snow%2C%20a%20lone%20figure%20in%20a%20dark%20coat%20at%20the%20pier%2C%20pale%20blue%20tones%20with%20a%20small%20warm%20lamp%20glow%2C%20desolate%20cinematic%20mood&width=1600&height=900&seq=sjs-12-still&orientation=landscape",
    featured: false,
    popularity: 79,
  },
  {
    id: "13",
    title: "中央车站",
    originalTitle: "Central do Brasil",
    year: 1998,
    region: "美国",
    genres: ["剧情", "家庭"],
    rating: 8.5,
    duration: 113,
    director: "沃尔特·萨勒斯",
    writers: ["沃尔特·萨勒斯", "若昂·伊曼纽尔·卡内罗"],
    cast: [
      { name: "费尔南达·蒙特内格罗", role: "朵拉", note: "在车站替文盲代写信的老太太，刻薄是她的自我防御。" },
      { name: "维尼修斯·德·奥利维拉", role: "约书亚", note: "失去母亲的男孩，固执地要去见一个还不知情的父亲。" },
      { name: "玛丽莉娅·佩拉", role: "安娜", note: "约书亚的母亲，出场很短，却决定了整部电影的方向。" },
    ],
    tagline: "一趟送人回家的路，把自己也送了回来。",
    synopsis:
      "巴西里约的中央车站，朵拉每天替不识字的人写信，也习惯把不满意的信悄悄丢掉。安娜带着儿子约书亚来写信寻找丈夫，出门后遭遇车祸。朵拉最初把男孩卖给了一个中间人，良心不安后又把他抢了回来，两人开着借来的车向东北部的内陆出发。一路上的客车、宗教朝圣与小站，让这个爱说谎的老太太第一次认真地帮别人完成一件事。",
    analysis: [
      "公路片的结构让两个人的改变发生在移动中，越往内陆走，城市里的冷漠就越淡。",
      "费尔南达的表演把一个不讨喜的人物演成了可被理解的普通人，这是全片最动人的力量。",
    ],
    tags: ["公路电影", "巴西", "信件", "经典"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20earth%20tone%20film%20poster%2C%20an%20old%20wooden%20desk%20with%20handwritten%20letters%20and%20a%20pen%2C%20sunlight%20through%20a%20dusty%20window%2C%20amber%20and%20deep%20brown%20palette%2C%20film%20grain%2C%20nostalgic%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=sjs-13-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Dusty%20Brazilian%20highway%20at%20golden%20hour%2C%20old%20bus%20stopped%20by%20a%20small%20roadside%20shrine%2C%20dry%20brush%20and%20warm%20orange%20dust%20in%20the%20air%2C%20nostalgic%201990s%20film%20look&width=1600&height=900&seq=sjs-13-still&orientation=landscape",
    featured: false,
    popularity: 68,
  },
  {
    id: "14",
    title: "阮玲玉",
    originalTitle: "Center Stage",
    year: 1991,
    region: "中国香港",
    genres: ["传记", "剧情", "历史"],
    rating: 8.2,
    duration: 154,
    director: "关锦鹏",
    writers: ["邱刚健", "关锦鹏"],
    cast: [
      { name: "张曼玉", role: "阮玲玉", note: "把一代影星演到近乎附体，访谈段落里又抽身出来谈自己。" },
      { name: "梁家辉", role: "蔡楚生", note: "导演，是阮玲玉在片场最信任的人，也是最沉默的旁观者。" },
      { name: "秦汉", role: "唐季珊", note: "富商，他给的爱带着占有的形状。" },
      { name: "吴启华", role: "张达民", note: "旧日恋人，用纠缠把她一步步逼向绝境。" },
    ],
    tagline: "人言可畏，四个字写尽了一个明星的一生。",
    synopsis:
      "影片在纪录片与剧情片之间来回切换：一边是张曼玉饰演的阮玲玉，从默片时代走向有声电影，在感情与舆论的夹击里逐渐失去立足之地；另一边是演员与导演讨论角色的采访片段，把「如何扮演一个被谈论的人」也变成故事的一部分。1935 年 3 月，阮玲玉留下「人言可畏」四字，结束了二十五年的生命。",
    analysis: [
      "混杂纪录素材的做法在这部电影里不是炫技，而是必要的结构：一个被大众消费的女性，只能被多层叙述才能接近。",
      "张曼玉在访谈中说自己无法完全成为阮玲玉，这句话恰恰是影片的题眼——理解与扮演之间永远有距离。",
    ],
    tags: ["传记片", "默片时代", "女性", "港片经典"],
    poster:
      "https://readdy.ai/api/search-image?query=Vintage%201930s%20Shanghai%20cinema%20poster%20style%2C%20elegant%20woman%20silhouette%20with%20a%20bob%20haircut%20in%20soft%20focus%2C%20sepia%20and%20deep%20plum%20tones%2C%20ornamental%20art%20deco%20frame%2C%20textured%20aged%20paper%2C%20no%20text&width=600&height=900&seq=sjs-14-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=1930s%20Shanghai%20film%20studio%20set%2C%20large%20vintage%20movie%20camera%2C%20scattered%20spotlights%20and%20cables%2C%20sepia%20warm%20tones%20with%20soft%20haze%2C%20nostalgic%20archival%20atmosphere&width=1600&height=900&seq=sjs-14-still&orientation=landscape",
    featured: false,
    popularity: 64,
  },
  {
    id: "15",
    title: "火山挚恋",
    originalTitle: "Fire of Love",
    year: 2022,
    region: "法国",
    genres: ["纪录片", "传记"],
    rating: 8.3,
    duration: 98,
    director: "萨拉·多萨",
    writers: ["萨拉·多萨", "肖恩·博特"],
    cast: [
      { name: "卡蒂娅·克拉夫特", role: "本人（档案影像）", note: "火山学家，把观测记录写得像诗，也像遗书。" },
      { name: "莫里斯·克拉夫特", role: "本人（档案影像）", note: "火山学家，痴迷于靠近正在喷发的火山口。" },
      { name: "米兰达·朱丽", role: "旁白", note: "用一种克制又亲近的语气，讲完两个人的一生。" },
    ],
    tagline: "他们爱火山，也爱彼此，最后一起留在火山里。",
    synopsis:
      "上世纪六十年代，卡蒂娅与莫里斯在阿尔萨斯相识，从此把一生交给了活火山。他们用 16 毫米摄影机拍下红色的熔岩湖、灰白的火山灰与喷发时的震颤，在全世界最危险的地方安营。1991 年日本云仙岳喷发，两人与其他火山学家一起罹难。影片几乎全部由他们留下的档案影像构成，镜头里没有恐惧，只有近乎宗教般的专注。",
    analysis: [
      "档案影像本身就是叙述者，热度与颜色无需解释，观众的敬畏几乎是被画面直接赋予的。",
      "这部纪录片最动人的不是冒险，而是两个人如何把共同的痴迷经营成一种可靠的陪伴。",
    ],
    tags: ["纪录片", "自然", "爱情", "档案影像"],
    poster:
      "https://readdy.ai/api/search-image?query=Dramatic%20minimalist%20documentary%20poster%2C%20glowing%20orange%20lava%20flow%20against%20dark%20volcanic%20rock%2C%20tiny%20human%20silhouettes%20at%20the%20edge%2C%20deep%20charcoal%20and%20luminous%20amber%2C%20film%20grain%2C%20awe%20inspiring%20composition%2C%20no%20text&width=600&height=900&seq=sjs-15-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Volcanic%20crater%20at%20night%20with%20molten%20lava%20glowing%20bright%20orange%2C%20black%20basalt%20rubble%2C%20plumes%20of%20steam%2C%20two%20small%20figures%20in%20protective%20gear%20observing%20from%20a%20ridge%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=sjs-15-still&orientation=landscape",
    featured: true,
    popularity: 90,
  },
  {
    id: "16",
    title: "你的名字。",
    originalTitle: "君の名は。 / Your Name",
    year: 2016,
    region: "日本",
    genres: ["爱情", "青春", "剧情"],
    rating: 8.6,
    duration: 106,
    director: "新海诚",
    writers: ["新海诚"],
    cast: [
      { name: "神木隆之介", role: "立花泷", note: "东京高中生，醒来时突然拥有了另一个人的日常。" },
      { name: "上白石萌音", role: "宫水三叶", note: "山间小镇的巫女，渴望离开又深深牵挂着故乡。" },
      { name: "长泽雅美", role: "奥寺美纪", note: "泷的打工前辈，是青春期心里最明亮的一次心动。" },
    ],
    tagline: "重要的东西，不能忘记的东西，名字。",
    synopsis:
      "三叶生活在飞驒山间的小镇，厌倦了小镇的琐碎；泷在东京读高中，过着被打工和电车切碎的日子。某天起，两人开始在梦里互换身体，用对方的生活应付考试、社交与家务，并靠手机留言维持联系。当他们决定见面时，发现彼此之间隔着一场彗星灾难与三年的时差。黄昏之时，两人终于看见对方，却只来得及在掌心写下名字。",
    analysis: [
      "新海诚第一次把科幻设定和灾难记忆结合起来，让「距离」既指恋爱，也指时间与地域。",
      "影片对小镇的描写不浪漫化，三叶的逃离是真实的欲望，这让最后的回归更有说服力。",
    ],
    tags: ["动画", "时间交错", "青春", "新海诚"],
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20animated%20film%20poster%2C%20two%20teenagers%20standing%20on%20opposite%20sides%20of%20a%20sunset%20sky%20with%20a%20split%20horizon%2C%20warm%20amber%20and%20deep%20violet%20gradient%2C%20comet%20trail%2C%20soft%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=sjs-16-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Anime%20style%20twilight%20landscape%20of%20a%20stepped%20shrine%20atop%20a%20mountain%20overlooking%20a%20small%20town%2C%20a%20bright%20comet%20crossing%20the%20deep%20orange%20and%20navy%20sky%2C%20painterly%20clouds%2C%20warm%20glowing%20lanterns&width=1600&height=900&seq=sjs-16-still&orientation=landscape",
    featured: false,
    popularity: 91,
  },
];

export const getFilmById = (id?: string) => films.find((film) => film.id === id);